import { render, staticRenderFns } from "./GanttChartV4.vue?vue&type=template&id=0c55f43a&scoped=true&"
import script from "./GanttChartV4.vue?vue&type=script&lang=js&"
export * from "./GanttChartV4.vue?vue&type=script&lang=js&"
import style0 from "./GanttChartV4.vue?vue&type=style&index=0&id=0c55f43a&lang=scss&scoped=true&"
import style1 from "./GanttChartV4.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55f43a",
  null
  
)

export default component.exports